import DatapointCollection from '@/datatypes/DatapointCollection';
import DocumentsByStatus from '@/datatypes/documents/ByStatus';

export default class EnterpriseStats {
  public totalDocuments: number;
  public totalDocumentsSent: number;
  public totalDocumentsSentLast12Months: number;
  public totalDocumentsSentThisYear: number;
  public totalDocumentsCreatedLast12Months: number;
  public totalDocumentsCreatedThisYear: number;
  public documentsSentLast12Months: DatapointCollection;
  public documentsCreatedLast12Months: DatapointCollection;
  public documentsByStatus: DocumentsByStatus;
  public documentsSentInPeriod: number;
  public documentQuotaDelta: number;

  constructor(options) {
    this.totalDocuments = options.totalDocuments;
    this.totalDocumentsSent = options.totalDocumentsSent;
    this.totalDocumentsSentLast12Months = options.totalDocumentsSentLast12Months;
    this.totalDocumentsSentThisYear = options.totalDocumentsSentThisYear;
    this.totalDocumentsCreatedLast12Months = options.totalDocumentsCreatedLast12Months;
    this.totalDocumentsCreatedThisYear = options.totalDocumentsCreatedThisYear;
    this.documentsByStatus = options.documentsByStatus;
    this.documentsSentLast12Months = options.documentsSentLast12Months;
    this.documentsCreatedLast12Months = options.documentsCreatedLast12Months;
    this.documentsSentInPeriod = options.documentsSentInPeriod;
    this.documentQuotaDelta = options.documentQuotaDelta;
  }

  public render() {
    return {
      totalDocuments: this.totalDocuments,
      documentsByStatus: this.documentsByStatus,
      documentsSentLast12Months: this.documentsSentLast12Months,
      documentsCreatedLast12Months: this.documentsCreatedLast12Months,
    };
  }
}
